import React from "react";
import { FiMapPin } from "react-icons/fi";
import Logo from "../styles/Black-SVG-Landscape.svg";
import ChrisPhoto from "../candidates/DAWNB.jpg";



export default function HeadOfPartnershipsDawnB() {
 const candidateProfileCopy = {
  name: "Dawn",
  location: "Autaugaville, AL",
  compensation: {
    range: "$150K guaranteed minimum",
  },
  availability: "Available within 2 weeks of offer, likely sooner",

  working_style:
    "Dawn is a relationship first sales leader who goes straight to the top. She builds genuine, lasting relationships with the executives who actually sign the deals, and she keeps them through relentless, personal follow up, handwritten notes, remembering the small details, and staying in touch for years. She is intensely driven and revenue focused, with more than three decades in healthcare sales and the ownership mindset of someone who has built and run her own company.",

  loom_video_link: "https://fathom.video/share/Z8GSNvbPBD9nWF-gAF9_65Rin3eFuz8F",

  tools: [
    {
      category: "Executive Relationships",
      items: [
        "Opening and holding C suite relationships at scale",
        "Long term trust built over years, not transactions",
        "Negotiating complex, multi year agreements",
      ],
    },
    {
      category: "Outreach & Follow Up",
      items: [
        "A disciplined multi touch system across phone, email, and text",
        "Persistent, personal follow up that gets replies",
        "Targeting accounts by revenue using sales intelligence tools",
      ],
    },
    {
      category: "Building & Leading",
      items: [
        "Founded and ran a national organization across 48 states",
        "Built and managed a network of 500 plus people",
        "Coaching reps to their own strengths with weekly accountability",
      ],
    },
    {
      category: "Healthcare & Compliance",
      items: [
        "30 plus years in healthcare sales and partnerships",
        "Deep HIPAA and healthcare compliance familiarity",
        "Experience across OBGYN and major physician groups",
      ],
    },
  ],

  soft_skills: [
    "30 plus years in healthcare sales and partnerships",
    "Founded and ran a national organization across 48 states",
    "Generated over $94M in revenue in the last five years",
    "Relentless, personal follow up that builds lasting trust",
  ],

  about_candidate:
    "Dawn has spent more than 30 years in healthcare sales, business development, and strategic partnerships, generating over $94M in revenue in the last five years alone. She also founded and ran her own national organization across 48 states, building and leading a network of more than 500 people. She has opened and grown relationships with major health systems and physician groups across the country, including OBGYN groups, and she is known for getting to the decision maker and building trust that lasts, with deep familiarity with the regulated, compliance heavy side of healthcare.",

  core_strengths: [
    {
      headline: "Gets to the decision maker and keeps them",
      description:
        "Dawn goes straight to the executives who actually sign, builds real relationships with them, and keeps those relationships alive for years through personal, thoughtful follow up. For a pharmacy that needs trusted relationships with clinic leaders, that executive access is a real asset.",
    },
    {
      headline: "Built and ran her own company",
      description:
        "Beyond selling for others, Dawn founded and led a national organization across 48 states with a network of more than 500 people, owning the business development, operations, and finances. That ownership mindset means she thinks like a builder and operator, with the drive to match.",
    },
    {
      headline: "A relentless, personal follow up machine",
      description:
        "Her outreach is a disciplined system of repeated touches across phone, email, and text, paired with handwritten notes, small gifts, and remembering the little details like a client's dog's name. She rarely lets a relationship go cold.",
    },
    {
      headline: "Knows healthcare and its rules cold",
      description:
        "More than three decades inside healthcare, including years in revenue cycle and patient services and extensive compliance training, mean she is completely at home in a regulated, HIPAA heavy environment.",
    },
  ],

  relevant_experience: [
    {
      headline: "Senior Director, Strategic Partnerships | Medstaff | 2023 to Present",
      bullets: [
        "Leads national growth through executive relationships and strategic partnerships",
        "Drives enterprise business development and complex contract negotiations",
        "Aligns sales strategy with leadership on long term revenue growth",
      ],
    },
    {
      headline: "Founder and CEO | 4PB Inc. | 2005 to 2022",
      bullets: [
        "Founded, scaled, and led a national organization operating across 48 states",
        "Built and managed a network of more than 500 professionals",
        "Directed business development, operations, finances, and client acquisition",
      ],
    },
    {
      headline: "Senior Account Executive | KPG Provider Services | 2021 to 2023",
      bullets: [
        "Drove national revenue growth through full cycle business development",
        "Originated and closed strategic partnerships with healthcare organizations nationwide",
        "Named Quick Start Producer of the Year",
      ],
    },
    {
      headline: "Senior Director, Business Development | Cross Country Healthcare | 2020 to 2021",
      bullets: [
        "Grew enterprise accounts through strategic expansion and market development",
        "Negotiated complex agreements and service models with senior leadership",
        "Opened new relationships with executive decision makers",
      ],
    },
  ],
};

const technicalAssessment = {
  meta: {
    role: "Head of Healthcare Partnerships",
    interviewDate: "June 9, 2026",
    analyst: "AI Architechs Senior Hiring Analysis",
  },

  snapshot:
    "Dawn is an intense, relationship first sales leader with more than 30 years in healthcare, including building and running her own national organization across 48 states. She gets straight to the executives who sign the deals, builds trust that lasts for years, and follows up relentlessly, and she is deeply revenue driven with real OBGYN and physician group experience. Two things to align on early: her partnership wins are largely in healthcare staffing rather than prescription referrals, so that model is a ramp, and she prefers large, high revenue accounts and said she does not chase smaller ones, which is worth squaring with a plan that signs many clinics. On pay, she needs $150K guaranteed, structured as a base plus a guaranteed first year commission, so that is worth working out up front.",

  scorecard: [
    {
      dimension: "Partnership and Referral Channel Development",
      score: 8,
      rationale:
        "More than 30 years opening and growing partnerships with major health systems and physician groups, generating over $94M in five years, plus building her own company's book of business. Deep, proven relationship and partnership building at the executive level, with the caveat that her channels have been in healthcare staffing rather than prescription referrals.",
    },
    {
      dimension: "Building From Zero and Pipeline Construction",
      score: 8,
      rationale:
        "She founded and scaled her own national organization across 48 states, building the whole operation and a 500 person network from the ground up, which is real proof she can build from nothing. Her in interview plan for this specific vertical leaned on direction from leadership first, but the track record of building a company carries the score.",
    },
    {
      dimension: "Revenue and Commercial Thinking",
      score: 8,
      rationale:
        "Intensely revenue focused, and as a former owner she thinks about the whole business, not just the sale. She uses sales intelligence to check each account's revenue, sets clear thresholds, and prioritizes ruthlessly by dollars, though mostly toward the largest accounts.",
    },
    {
      dimension: "Partner Conversion and Lifecycle Management",
      score: 8,
      rationale:
        "She converts and keeps partners through relationships, expanding from one signed contact into the rest of an organization and staying close with personal, thoughtful follow up. Strong on long term retention, with less detail on a formal onboarding process.",
    },
    {
      dimension: "SDR and Sales Team Leadership",
      score: 8,
      rationale:
        "She has built and led teams as both a sales leader and a company owner, with a clear coaching philosophy: coach each rep to their own strengths, with weekly accountability on calls, touches, and engagement. Comfortable holding a team to the numbers.",
    },
    {
      dimension: "Regulated Healthcare Experience and Compliance",
      score: 9,
      rationale:
        "Decades inside healthcare, including years in revenue cycle and patient services and extensive compliance training. She is completely at home in a HIPAA heavy, regulated environment.",
    },
    {
      dimension: "Fertility and Women's Health Vertical Exposure",
      score: 7,
      rationale:
        "She has worked with OBGYN groups throughout her career, so women's health providers are familiar, but she has not worked with fertility clinics specifically. A short ramp on that exact vertical.",
    },
    {
      dimension: "Ambition and Drive",
      score: 9,
      rationale:
        "Exceptionally driven. She built and ran her own national company, works at an intense pace, is motivated by hitting big goals, and has generated over $94M in five years. The energy, ownership, and hunger are unmistakable.",
    },
  ],

  strengths: [
    {
      headline: "Executive access and trust",
      description:
        "Dawn gets to the decision makers who sign and builds relationships that last for years, which is the kind of trusted access a pharmacy needs with clinic leaders.",
    },
    {
      headline: "A builder and an operator",
      description:
        "Beyond selling, she founded and ran her own national company, so she thinks about the whole business, owns outcomes, and brings the drive of someone who has built something from nothing.",
    },
    {
      headline: "Relentless follow up",
      description:
        "Her disciplined, personal multi touch outreach means relationships rarely go cold, and people reply because they already know her name.",
    },
    {
      headline: "At home in healthcare compliance",
      description:
        "Decades inside the industry mean she moves easily through HIPAA and the regulated side without a learning curve.",
    },
  ],

  flags: [
    {
      headline: "Partnership experience is in staffing, not prescriptions",
      description:
        "Her wins are largely in healthcare staffing sales rather than building prescription referral channels. The executive relationship skills carry over directly, but the specific prescribing partnership model would be a ramp.",
    },
    {
      headline: "Built for whales, this role needs many clinics",
      description:
        "She prefers large, high revenue accounts and said plainly she does not chase smaller ones. That is worth aligning early against a plan that signs a high volume of clinics, including smaller fertility practices.",
    },
    {
      headline: "Guaranteed pay structure to work out",
      description:
        "She needs $150K guaranteed, structured as roughly a $110K base plus a guaranteed $40K first year commission, and wants evidence the commission is achievable. Worth settling the structure before advancing.",
    },
  ],

  when_to_hire: [
    "You want someone who can open and hold relationships with executive decision makers and keep them for years.",
    "You value an owner's mindset and someone who has built and run a business, not only sold for one.",
    "You want intense drive and a revenue first mindset from a seasoned healthcare seller.",
    "Deep comfort in regulated healthcare and the C suite is important to you.",
  ],

  when_to_be_cautious: [
    "Your plan depends on signing a high volume of clinics, including smaller practices, since she prefers large accounts.",
    "You want someone who already works in prescription referral partnerships, since her background is healthcare staffing.",
    "A flexible or fully variable pay structure is important to you, since she needs a guaranteed floor.",
  ],

  bottom_line:
    "Dawn brings three decades of healthcare sales, real executive access, relentless follow up, and the ownership mindset of someone who built and ran her own national company, along with deep comfort in a regulated environment and direct OBGYN experience. The questions to settle are fit with a many clinic, prescription referral model, since her wins are in staffing and large accounts, and her guaranteed pay structure. Where the role rewards trusted executive relationships, drive, and a builder's mindset, she is very strong.",
};

  const ScorePill = ({ score }) => {
    let bg = "#f97316";
    if (score >= 8) bg = "#22c55e";
    else if (score >= 6) bg = "#36D1FF";
    return (
      <span
        style={{ backgroundColor: bg }}
        className="inline-block text-white text-xs font-bold px-3 py-1 rounded-full"
      >
        {score} / 10
      </span>
    );
  };

  return (
    <div className="min-h-screen bg-[#01014C] text-white flex flex-col items-center py-10 px-4">

      {/* ===================== PAGE 1 ===================== */}
      <div className="w-full max-w-6xl bg-[#FFFDFB] rounded-3xl overflow-hidden shadow-2xl flex flex-col md:flex-row relative">

        {/* LEFT COLUMN */}
        <aside className="relative md:w-1/3 bg-gradient-to-b from-[#01014C] via-[#0A0A80] to-[#36D1FF] p-8 flex flex-col items-center text-center overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-b from-[#36D1FF]/30 to-transparent"></div>

          {/* Avatar placeholder */}
          <div className="relative mb-4">
            <div className="absolute inset-0 rounded-full bg-[#36D1FF]/20 blur-2xl"></div>
            <div className="relative w-36 h-36 rounded-full border-4 border-[#36D1FF] shadow-lg overflow-hidden">
              <img src={ChrisPhoto} alt="Chris Weston" className="w-full h-full object-cover" />
            </div>
          </div>

          {/* Name */}
          <h1 className="text-2xl font-semibold mb-1 text-[#FFFDFB]">
            {candidateProfileCopy.name}
          </h1>

          {/* Location */}
          <div className="flex items-center gap-2 text-[#E0F7FF] text-sm mb-6 opacity-90">
            <FiMapPin className="text-[#36D1FF]" />
            <span>{candidateProfileCopy.location}</span>
          </div>

          {/* Compensation */}
          <div className="bg-[#01014C] border border-[#36D1FF]/50 rounded-xl p-4 w-full text-left mb-4">
            <p className="text-[#B3E9FF] text-sm font-semibold uppercase mb-1">
              Compensation
            </p>
            <p className="text-[#36D1FF] text-lg font-bold">
              {candidateProfileCopy.compensation.range}
            </p>
          </div>

          {/* Availability */}
          <div className="bg-[#01014C] border border-[#36D1FF]/30 rounded-xl p-4 w-full text-left mb-6">
            <p className="text-[#E0F7FF] text-sm">
              {candidateProfileCopy.availability}
            </p>
          </div>

          {/* Watch Interview Button */}
          <a
            href={candidateProfileCopy.loom_video_link}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full mb-6 flex items-center justify-center gap-2 bg-gradient-to-r from-[#36D1FF] to-[#0099CC] hover:from-[#5DDDFF] hover:to-[#00AADD] text-[#01014C] font-bold text-sm py-3 px-6 rounded-xl transition-all duration-200 shadow-lg shadow-[#36D1FF]/20 hover:shadow-[#36D1FF]/40"
          >
            ▶ Watch Interview
          </a>

          {/* Tools */}
          <div className="w-full mt-4 mb-6 text-left">
            <h3 className="text-sm font-semibold mb-3 text-[#B3E9FF] uppercase">
              Tools & Capabilities
            </h3>
            {candidateProfileCopy.tools.map((group, i) => (
              <div key={i} className="mb-4">
                <p className="text-xs font-semibold text-[#36D1FF] mb-1 uppercase tracking-wide">
                  {group.category}
                </p>
                <ul className="space-y-1">
                  {group.items.map((tool, j) => (
                    <li
                      key={j}
                      className="flex items-start gap-2 text-xs text-[#E0F7FF]/90 leading-snug"
                    >
                      <span className="mt-1 w-1.5 h-1.5 rounded-full bg-[#36D1FF] shrink-0" />
                      {tool}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Soft Skills */}
          <div className="w-full mb-6 text-left">
            <h3 className="text-sm font-semibold mb-2 text-[#B3E9FF] uppercase">
              Key Profile Highlights
            </h3>
            <ul className="list-disc pl-5 space-y-1 text-[#E0F7FF] text-sm">
              {candidateProfileCopy.soft_skills.map((skill, i) => (
                <li key={i}>{skill}</li>
              ))}
            </ul>
          </div>

          {/* Logo placeholder */}
          <div className="w-full mt-8 flex justify-center">
            <img src={Logo} alt="AI Architechs" className="h-16 opacity-80" />
          </div>
        </aside>

        {/* RIGHT COLUMN */}
        <main className="flex-1 p-10 text-[#01014C] space-y-10">
          <section>
            <h2 className="text-xl font-semibold mb-3 border-b border-[#36D1FF]/40 pb-1">
              About this Candidate
            </h2>
            <p className="text-gray-700 leading-relaxed whitespace-pre-line">
              {candidateProfileCopy.about_candidate}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 border-b border-[#36D1FF]/40 pb-1">
              Core Strengths
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              {candidateProfileCopy.core_strengths.map((item, i) => (
                <div key={i} className="border border-[#36D1FF]/30 rounded-xl p-5">
                  <p className="font-semibold mb-1">{item.headline}</p>
                  <p className="text-sm text-gray-700">{item.description}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 border-b border-[#36D1FF]/40 pb-1">
              Relevant Experience
            </h2>
            <div className="space-y-6">
              {candidateProfileCopy.relevant_experience.map((exp, i) => (
                <div key={i} className="border border-[#36D1FF]/30 rounded-xl p-5">
                  <p className="font-semibold text-[#EB5D2A] mb-2">{exp.headline}</p>
                  <ul className="list-disc pl-6 space-y-1 text-sm text-gray-700">
                    {exp.bullets.map((b, j) => (
                      <li key={j}>{b}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </section>
        </main>
      </div>

      {/* ===================== PAGE BREAK BAND ===================== */}
      <div className="w-full py-10">
        <div className="max-w-6xl mx-auto px-4">
          <div className="h-10 rounded-2xl bg-gradient-to-r from-[#01014C] via-[#0A0A80] to-[#36D1FF] opacity-70 shadow-[0_0_40px_#36D1FF20]" />
        </div>
      </div>

      {/* ===================== PAGE 2 ===================== */}
      <div className="w-full max-w-6xl bg-[#FFFDFB] rounded-3xl overflow-hidden shadow-2xl pb-2">
        <main className="p-10 text-[#01014C]">
          <div className="border border-[#36D1FF]/25 rounded-2xl p-6 bg-white shadow-[0_0_12px_#36D1FF15]">

            {/* Header */}
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-2 mb-6">
              <h2 className="text-2xl font-semibold text-[#01014C]">
                Technical Analysis
              </h2>
              <div className="flex flex-col items-start md:items-end gap-1 text-xs text-gray-400">
                <span>{technicalAssessment.meta.role}</span>
                <span>Interview: {technicalAssessment.meta.interviewDate}</span>
                <span>{technicalAssessment.meta.analyst}</span>
              </div>
            </div>

            {/* Snapshot */}
            <div className="border border-[#36D1FF]/20 rounded-xl p-5 bg-[#36D1FF]/5 mb-6">
              <p className="text-base font-bold text-[#01014C] mb-2">Executive Fit Snapshot</p>
              <p className="text-gray-700 text-base leading-relaxed whitespace-pre-line">
                {technicalAssessment.snapshot}
              </p>
            </div>

            {/* Strengths & Flags */}
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ✅ Strengths
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.strengths.map((item, i) => (
                    <div key={i} className="border border-[#22c55e]/30 rounded-xl p-4 bg-[#22c55e]/5">
                      <p className="font-semibold text-sm text-[#01014C] mb-1">{item.headline}</p>
                      <p className="text-sm text-gray-700">{item.description}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ⚠️ Flags / Watch-outs
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.flags.map((item, i) => (
                    <div key={i} className="border border-[#f97316]/30 rounded-xl p-4 bg-[#f97316]/5">
                      <p className="font-semibold text-sm text-[#01014C] mb-1">{item.headline}</p>
                      <p className="text-sm text-gray-700">{item.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Scorecard */}
            <div className="mb-6">
              <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                Quantitative Scorecard
              </h3>
              <div className="overflow-x-auto rounded-xl border border-[#36D1FF]/25">
                <table className="w-full text-sm">
                  <thead className="bg-[#36D1FF]/10 text-[#01014C]">
                    <tr>
                      <th className="text-left font-semibold px-4 py-3">Dimension</th>
                      <th className="text-left font-semibold px-4 py-3 w-[120px]">Score</th>
                      <th className="text-left font-semibold px-4 py-3">Rationale</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#36D1FF]/15">
                    {technicalAssessment.scorecard.map((row, idx) => (
                      <tr key={idx} className="bg-white">
                        <td className="px-4 py-3 font-medium text-[#01014C] align-top">{row.dimension}</td>
                        <td className="px-4 py-3 align-top"><ScorePill score={row.score} /></td>
                        <td className="px-4 py-3 text-gray-700 whitespace-pre-line align-top">{row.rationale}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* When to Hire / Cautions */}
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ✅ Hire if…
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.when_to_hire.map((item, i) => (
                    <div key={i} className="border border-[#36D1FF]/30 rounded-xl p-4 bg-[#36D1FF]/5 text-sm text-gray-700">
                      {item}
                    </div>
                  ))}
                </div>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ⚠️ Be cautious or pass if…
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.when_to_be_cautious.map((item, i) => (
                    <div key={i} className="border border-[#f59e0b]/30 rounded-xl p-4 bg-[#f59e0b]/5 text-sm text-gray-700">
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Bottom Line */}
            <div className="border border-[#01014C]/20 rounded-xl p-5 bg-[#01014C]/5">
              <p className="text-sm font-bold text-[#01014C] mb-2 uppercase tracking-wide">
                🏁 Bottom Line
              </p>
              <p className="text-gray-700 text-sm leading-relaxed">
                {technicalAssessment.bottom_line}
              </p>
            </div>

          </div>
        </main>
      </div>

    </div>
  );
}